import { defineStore } from 'pinia'
import { actions, getters, state } from './ext/items.js'


export const usePaymentServiceStore = defineStore('paymentServices', {
  id: 'paymentServices',
  state: () => ({
    items: [],
    api: '/api/v1/payment-services'
  }),
  getters: {
    ...getters,
    getItemsByOrganizationId: (state) => (organizationId) => state.items.filter(item => item.payment_service_for_id === organizationId && item.payment_service_for_type === 'App\\Models\\Organization'),
  },
  actions: {
    ...actions,
    async createStripeSession(payload) {
      const { data } = await axios.post(`${this.api}/${payload.payment_service_id}/stripe/sessions`)
      return data
    },
    async checkStripeOnboardingStatus(payload) {
      const { data } = await axios.post(`${this.api}/${payload.payment_service_id}/check-if-details-submitted`)
      return data
    },
    async markAsDefault(paymentServiceId) {
      const { data } = await axios.post(`${this.api}/${paymentServiceId}/mark-as-default`)
      this.itemPatchState(data)
      return data
    },
    async checkIfDetailsSubmitted(paymentServiceId) {
      const { data } = await axios.post(`${this.api}/${paymentServiceId}/check-if-details-submitted`)
      this.itemPatchState(data)
      return data
    }
  }
})
